<template>
  <v-container
    fluid
  >
    <div>
      <v-row>
        <v-col>
          <v-toolbar
            class="align-items-center"
            color="transparent"
            flat
          >
            <v-card-title
              class="d-none d-sm-block pl-0"
            >
              {{ $t('locations.title') }}
            </v-card-title>

            <v-spacer />

            <v-text-field
              v-model="textSearch"
              append-inner-icon="mdi-magnify"
              :placeholder="$t('common.searchPlaceholder')"
              :disabled="loading"
              autofocus
              hide-details
              solo
            />

            <ListSearchButton
              class="ml-3"
              :loading="loading || searching"
              @click="onUserSearch"
            />
            <v-spacer />
            <CustomerLocationCreateDialog
              v-if="$store.getters.hasAnyPermission(['AdministrationCustomer', 'LocationCreate'])"
              :customer-id="$store.state.primaryCustomerId"
              @create:success="fetchData"
            />
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row
        align="start"
      >
        <v-col>
          <v-data-table
            :headers="headers"
            :items="locations"
            :loading="loading"
            :search="textSearch"
            :items-per-page ="15"
            :footer-props="{ 'items-per-page-options': [15, 30, 50, 75, -1] }"
            :sort-by="['deliveryCount', 'supportTicketCount', 'taskRequestCount']"
            :sort-desc="[true, true, true]"
            multi-sort
            :group-by.sync="groupBy"
            @click:row="({ id }) => $router.push(`/locations/${id}`)"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading';
import ListFilters from '@/components/ListFilters.vue';
import ListSearchButton from '@/components/ListSearchButton.vue';
import CaseCardSkeletonLoader from '@/components/CaseCardSkeletonLoader.vue';
import LocationStatus from '@/components/LocationStatus.vue';
import CustomerLocationCreateDialog from '@/components/customer/CustomerLocationCreateDialog.vue';

export default {
  name: 'LocationsList',
  components: {
    Loading,
    ListFilters,
    ListSearchButton,
    CaseCardSkeletonLoader,
    LocationStatus,
    CustomerLocationCreateDialog
  },
  data() {
    return {
      metadata: {},
      query: {
        includeCounts: true,
        readonly: false
      },
      groupBy: null,
      textSearch: null,
      locations: [],
      loading: false,
      countryInput: null,
      searching: false,
    };
  },
  computed: {
    ...mapGetters(['showOnlyRelevantContent']),
    headers() {
      return [
        {
          text: this.$t('common.name'),
          value: 'title',
          groupable: false,
          width: 300
        },
        {
          text: this.$t('common.country'),
          value: 'countryName'
        },
        {
          text: this.$t('common.area'),
          value: 'areaName',
          width: '15%'
        },
        {
          text: this.$tc('common.type'),
          value: 'typeName',
          width: '10%'
        },
        {
          text: this.$tc('common.delivery', 2),
          value: 'deliveryCount',
          groupable: false,
          align: 'right',
          width: 190
        },
        {
          text: this.$tc('common.supportTicket', 2),
          value: 'supportTicketCount',
          groupable: false,
          align: 'right',
          width: 190
        },
        {
          text: this.$tc('common.taskRequest', 2),
          value: 'taskRequestCount',
          groupable: false,
          align: 'right',
          width: 190
        }
      ]
    }
  },
  watch: {
    showOnlyRelevantContent() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;

      try {
        const { data } = await this.$api.get('locations', {
          params: this.query
        });

        this.locations = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async onUserSearch() {
      this.locations = [];
      this.$vuetify.goTo(0);
      this.fetchData();
    },
  }
};
</script>

<style>
.v-data-table tr { cursor: pointer; }
</style>
